import React from 'react';
import { PropTypes } from 'prop-types';
import MCheckbox from '../../../../atoms/MCheckbox';

const CheckboxCell = ({ row, updateValue, qboMappingId }) => {
  const handleChange = () => {
    if (!row.original?.quickBooksId) return;
    updateValue(row.original.quickBooksId);
  };

  return (
    <MCheckbox isChecked={row.original.quickBooksId === qboMappingId} onChange={handleChange} />
  );
};

CheckboxCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({ quickBooksId: PropTypes.number }),
  }).isRequired,
  updateValue: PropTypes.func.isRequired,
  qboMappingId: PropTypes.number.isRequired,
};

export default React.memo(CheckboxCell);
